import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "master-new-form container-hjp-confirm-modal" }
const _hoisted_2 = { class: "flex items-center justify-end gap-3 mt-6" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Simpan")

import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Button from 'primevue/button'
import Card from 'primevue/card'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'

// Composables
import { useMandoranCommissionTiers } from '@/composables/pages/master-setting/mandoran-commission/useMandoranCommissionTiers'
import { useMandoranCommissionForm } from '@/composables/pages/master-setting/mandoran-commission/useMandoranCommissionForm'

// Subcomponents
import FormHeader from './components/FormHeader.vue'
import FormGeneralInfo from './components/FormGeneralInfo.vue'
import FormRitCommission from './components/FormRitCommission.vue'
import FormPassengerCommission from './components/FormPassengerCommission.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const backRouteName = 'master-mandoran-commission'
const store = useStore()
const route = useRoute()
const router = useRouter()

const idPrams = ref<any>(null)

const modalConfirmation = ref({
  show: false,
  title: 'Simpan Komisi Mandoran?',
  subTitle: 'Data komisi mandoran akan disimpan. Yakin simpan data?',
  imgContent: require('@/assets/img/modal-confirmation/price-add-update.svg'),
  btnSubmitTitle: 'Simpan',
  btnBackTitle: 'Kembali'
})

const {
  tiers,
  tiersGeneralError,
  originalTiers,
  validateTiers,
  addTierRow,
  removeTierRow,
  onTierInput,
  setTiersFromData
} = useMandoranCommissionTiers()

const {
  values,
  errors,
  setFieldValue,
  setFieldError,
  validateField,
  handleSubmit,
  nameDuplicateError,
  checkNameIsDuplicate,
  cancelDebouncedNameCheck,
  handleNameInput,
  handleFieldChange,
  handleNumberInput,
  getDataDetail,
  saveCommission
} = useMandoranCommissionForm()

const toPrevPage = () => {
  router.push({
    name: backRouteName
  })
}

const onSelectCommissionType = (type: string) => {
  setFieldValue('commissionType', type)
  validateField('commissionType')
  if (type === 'Tiered' && tiers.value.length === 0) {
    addTierRow()
  }
}

const onSubmit = handleSubmit(async () => {
  if (values.commissionType === 'Tiered') {
    const isTiersValid = validateTiers('Tiered')
    if (!isTiersValid) {
      return
    }
  }

  cancelDebouncedNameCheck()
  if (values.name && values.name.trim().length >= 3) {
    store.dispatch('showLoading')
    try {
      const isDuplicate = await checkNameIsDuplicate(values.name, idPrams.value?.Id)
      if (isDuplicate) {
        nameDuplicateError.value = 'duplicate'
        setFieldError('name', 'Nama Komisi sudah digunakan')
        return
      }
    } finally {
      store.dispatch('hideLoading')
    }
  }

  modalConfirmation.value.show = true
})

const onConfirmSave = async () => {
  modalConfirmation.value.show = false
  try {
    await saveCommission({
      commissionId: idPrams.value?.Id || null,
      tiers: tiers.value,
      originalTiers: originalTiers.value
    })
    toPrevPage()
  } catch (err) {
    // Error notification handled in composable
  }
}

const loadDetail = async (id: string) => {
  try {
    await getDataDetail(id, (tiersList, commissionType) => {
      setTiersFromData(tiersList, commissionType)
    })
  } catch (error) {
    toPrevPage()
  }
}

onMounted(() => {
  let editOrAdd = 'Tambah'
  if (route.params.id) {
    try {
      const decrypted = encryptDecriptMethods.decrypt(route.params.id as string)
      if (decrypted && decrypted.Id) {
        idPrams.value = decrypted
        editOrAdd = 'Edit'
        loadDetail(decrypted.Id)
      }
    } catch (e) {
      console.error('Decrypt failed', e)
    }
  }

  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Komisi Mandoran',
      routeName: backRouteName
    },
    {
      title: `${editOrAdd} Komisi`,
      routeName: 'master-mandoran-commission-form',
      params: { id: route.params.id }
    }
  ])
})

onBeforeUnmount(() => {
  cancelDebouncedNameCheck()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
    }, [
      _createVNode(_unref(Card), { class: "card-no-shadow" }, {
        content: _withCtx(() => [
          _createVNode(FormHeader),
          _createVNode(FormGeneralInfo, {
            values: _unref(values),
            errors: _unref(errors),
            onChangeName: _cache[0] || (_cache[0] = (val) => _unref(handleNameInput)(val, idPrams.value?.Id)),
            onChangeField: _unref(handleFieldChange),
            onBlurField: _cache[1] || (_cache[1] = (f) => _unref(validateField)(f))
          }, null, 8, ["values", "errors", "onChangeField"]),
          _createVNode(FormRitCommission, {
            values: _unref(values),
            errors: _unref(errors),
            tiers: _unref(tiers),
            tiersGeneralError: _unref(tiersGeneralError),
            onSelectType: onSelectCommissionType,
            onChangeNumber: _unref(handleNumberInput),
            onBlurField: _cache[2] || (_cache[2] = (f) => _unref(validateField)(f)),
            onTierInput: _unref(onTierInput),
            onBlurTiers: _cache[3] || (_cache[3] = () => _unref(validateTiers)('Tiered')),
            onAddTier: _unref(addTierRow),
            onRemoveTier: _cache[4] || (_cache[4] = (idx) => _unref(removeTierRow)(idx))
          }, null, 8, ["values", "errors", "tiers", "tiersGeneralError", "onChangeNumber", "onTierInput", "onAddTier"]),
          _createVNode(FormPassengerCommission, {
            values: _unref(values),
            errors: _unref(errors),
            onChangeNumber: _unref(handleNumberInput),
            onBlurField: _cache[5] || (_cache[5] = (f) => _unref(validateField)(f))
          }, null, 8, ["values", "errors", "onChangeNumber"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Button), {
              type: "button",
              class: "btn-back",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (toPrevPage()))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              type: "submit",
              class: "btn-primary"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ], 32),
    _createVNode(HjpConfirmationModal, {
      show: modalConfirmation.value.show,
      imgContent: modalConfirmation.value.imgContent,
      title: modalConfirmation.value.title,
      subTitle: modalConfirmation.value.subTitle,
      btnSubmitTitle: modalConfirmation.value.btnSubmitTitle,
      btnBackTitle: modalConfirmation.value.btnBackTitle,
      onHideDialog: _cache[8] || (_cache[8] = ($event: any) => (modalConfirmation.value.show = false)),
      onOnSubmit: onConfirmSave
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "btnBackTitle"])
  ]))
}
}

})